import React from "react";
import styles from "./stylesComponent/CardProduct.module.css";
import { FaStar } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import { FaStarHalfAlt } from "react-icons/fa";
import {Link} from 'react-router-dom';


const CardTutor = ({ tutor }) => {

    //Valoracion y datos del tutor del producto pasado
    const { rating } = tutor;

    return(
        /*En cada tarjeta se muestra imagen, nombre del contenido, autor y temática (al menos 2, si hay más se muestran ...) */
        <div className={styles.card}>
            <div className={styles.image}>
                <img src={`data:image/png;base64,${tutor.ImagenPerfil}`} alt={`${tutor.Nombre} ${tutor.Apellidos}`} />
            </div>
            <div className={styles.nombre}>
                <h3>{tutor.Nombre}  {tutor.Apellidos}</h3>
            </div>
            <div>
                <strong><p className={styles.tutor}>{tutor.Usuario}</p></strong>
                {//<p className={styles.descripcion} title={tutor.Correo} style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', Width: '90%'}}>{tutor.Correo}</p>}}
                }
                <div className={styles.tematicas} title={tutor.Tematicas?.join(", ")}>
                    <span>Especializado en: </span><br/>
                    <span>{tutor.Tematicas?.join(", ")}</span>
                </div>
            </div>
                <div className={styles.valoracionPrecio} style={{ display: 'block', alignSelf: 'left'}}>
                    <span>
                        {Array.from({length: 5}, (_, index) =>{
                            const entero = Math.floor(rating);
                            const decimal = rating - entero;

                            if(index < entero) {
                                return <FaStar key={index} />;
                            }
                            else if (index === entero && decimal > 0.4){
                                return <FaStarHalfAlt key={index} />;
                            }
                            else{
                                return <FaRegStar key={index} />;
                            }
                        })}
                    </span>
                </div>
                <div className={styles.boton}>
                    <Link to={{ pathname: `/detalleTutor/${tutor._id}`, state: { tutor: tutor }}} >
                        <button>Ver Detalles</button>
                    </Link>
                </div>
        </div>
    );
};

export default CardTutor;